import axios from 'axios';

const state = () => ({
    list : [],
    loading: false,
    allLoaded : false,
})

const getters = {

}

const actions = {
    async load({commit, state, rootState}){
        commit("isLoading", true);
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/documentTypes").then((response) => {
                commit("set", response.data.data);
                commit("isLoading", false);
            })
        }
        commit("isLoading", false);
    }
}

const mutations = {
    set(state, list){
        if(list == undefined || list.length <= 0){
            state.allLoaded = true;
        }
        state.list = list;
    },
    clean(state){
        state.list = [];
        state.loaded = false;
        state.allLoaded = false;
    },
    isLoading(state, status){
        state.loading = status;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }